import './intro.scss';
import React, { useLayoutEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const Intro: React.FC = () => {
  const introRef = useRef<HTMLElement>(null);
  const textRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      // Effetto blocco mentre scorre
      ScrollTrigger.create({
        trigger: introRef.current,
        start: "top top",
        end: "+=130%",
        pin: true,
        scrub: 1,
      });

      // Anima parola per parola
      const words = textRef.current?.querySelectorAll(".word");
      if (words) {
        gsap.fromTo(
          words,
          { color: "rgba(248, 248, 248, 0.2)" },
          {
            color: "rgba(248, 248, 248, 1)",
            stagger: 0.2, // Ritardo tra una parola e l'altra
            ease: "none",
            scrollTrigger: {
              trigger: introRef.current,
              start: "top top",
              end: "bottom top",
              scrub: 1,
            },
          }
        );
      }
    });

    return () => ctx.revert();
  }, []);

  // Primo blocco di testo
  const firstLine = "I am a Digital Product Designer with eight years of experience in Web Design and Front-End Development, working both with private clients and large companies";
  const firstWords = firstLine.split(" ").map((word, i) => (
    <span key={`f-${i}`} className="word inline-block intro-text-standard">{word}&nbsp;</span>
  ));

  // Spazio per il doppio a capo
  const lineBreaks = [
    <br key="br1" />,
    <br key="br2" />,
    <br key="br2" />
  ];

  // Secondo blocco di testo
  const secondLine = "Awarded the iF Design Award in 2026 — a milestone I’m deeply proud of";
  const secondWords = secondLine.split(" ").map((word, i) => (
    <span key={`s-${i}`} className="word inline-block award-line">{word}&nbsp;</span>
  ));

  // Combina tutto
  const words = [...firstWords, ...lineBreaks, ...secondWords];

  return (
    <section
      id="about"
      ref={introRef}
      className="intro grid grid-cols-12 gap-6 flex flex-col items-center bg-dark text-light px-6 py-6"
    >
      <div className="col-span-12 lg:col-span-10 lg:col-start-2">
        <h3 ref={textRef}>{words}</h3>
      </div>
    </section>
  );
};

export default Intro;